/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
	resource_id: string;
	resource_type: string;
}

interface ResourceData {
	id: number;
	id_prefix_value: number;
	resource_id: string;
	file_name: string;
	file_duration: string;
	url: string;
	transcoding_url: string;
	transcoding_ext: string;
	thumb_info: string[];
	vod_file_id: string;
	vod_transcoding_url: string;
	status: string;
	is_recycle: number;
	is_deleted: number;
	regular_deleted_by_eid: number;
	is_live: number;
	live_session_status: string;
	create_time: number;
	resource_type: number;
  }

interface IOutput {
	resource_data: ResourceData;
}

export const getResourceInfo = (data: IInput): Promise<IResponse<IOutput>> => {
	return fetchData(Api.GET_RESOURCE_INFO, data).then((res: IResponse<IOutput>) => {
		return res;
	});
};

export interface IStatusResource {
	create_time: string;
	delete_time: string;
	ext: string;
	file_duration?: string;
	file_name: string;
	file_size: string;
	id: string;
	id_prefix_type: string;
	id_prefix_value: string;
	is_deleted: string;
	is_live: string;
	is_recycle: string;
	live_session_id: string;
	live_session_status: string;
	live_session_url: string;
	live_session_url_flv: string;
	live_session_url_rtmp: string;
	live_vendor: string;
	media_type: string;
	regular_deleted_by_eid: string;
	resource_type: number;
	status: string;
	stream_name: string;
	thumb_info: string;
	transcoding_ext: string;
	transcoding_rule_id: string;
	transcoding_url: string;
	update_time: string;
	url: string;
	vod_file_id: string;
	vod_transcoding_url: string;
  }


export const getResourceListInfo = (data: {resource: string}): Promise<IResponse<IStatusResource[]>> => {
	return fetchData(Api.GET_RESOURCE_LIST_INFO, data).then((res: IResponse<IStatusResource[]>) => {
		return res;
	});
};

export const getResourceInfoSync = fetchDataSync(getResourceInfo);
